// extracted by mini-css-extract-plugin
module.exports = {"header":"FuwModal_header__3Mos6","close":"FuwModal_close__5bpbd"};